export function capitalizeFirstLetter(lowercaseString: string): string {
  return lowercaseString.charAt(0).toUpperCase() + lowercaseString.slice(1);
}
